import workspace from "../assets/images/HostingResponsibilities.png";

function HostResponsibilities() {
  return (
    <div>
      {/* Hero section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Host Responsibilities</h1>
          <p>
            AirArrange is built on trust, professionalism, and reliability.
            Hosts play a critical role in ensuring a positive experience for
            tenants by providing accurate information, timely access, and
            responsive communication.
          </p>
          <p>
            This page outlines the responsibilities and expectations of hosts
            who list and manage workspaces on the AirArrange platform.
          </p>
        </div>

        <div className="hero-image">
          <img src={workspace} alt="Host responsibilities" />
        </div>
      </section>

      {/* Content */}
      <section className="max-w-5xl mx-auto px-6 py-16 space-y-12">
        {/* General duties */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            General Responsibilities of Hosts
          </h2>
          <p className="text-gray-600">
            Hosts are expected to act professionally and in good faith when
            interacting with tenants and prospective tenants. This includes
            complying with applicable Australian laws, honouring confirmed
            bookings, and maintaining transparent communication.
          </p>
        </div>

        {/* Accurate listings */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Accurate and Honest Listings
          </h2>
          <p className="text-gray-600">
            Hosts must ensure that all workspace listings are accurate, current,
            and not misleading. This includes providing clear information about:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2 mt-3">
            <li>Workspace type, size, and permitted use</li>
            <li>Availability and booking times</li>
            <li>Pricing, fees, and inclusions</li>
            <li>Access conditions and any usage restrictions</li>
          </ul>
        </div>

        {/* Access obligations */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Granting Timely Access to the Workspace
          </h2>
          <p className="text-gray-600">
            Hosts are responsible for ensuring tenants can access the workspace
            at the agreed start time of their booking or lease.
          </p>
          <p className="text-gray-600 mt-2">
            Any access instructions, keys, codes, or entry requirements must be
            provided in advance and without unreasonable delay.
          </p>
        </div>

        {/* Communication */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Communication and Responsiveness
          </h2>
          <p className="text-gray-600">
            Hosts are expected to maintain reasonable and professional
            communication with tenants. This includes:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2 mt-3">
            <li>Responding to enquiries within 24–72 hours</li>
            <li>Providing timely updates regarding access or changes</li>
            <li>Addressing reasonable concerns related to the workspace</li>
          </ul>
        </div>

        {/* Maintenance */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Workspace Condition and Safety
          </h2>
          <p className="text-gray-600">
            Hosts are responsible for ensuring that the workspace is provided in
            a condition consistent with its description and suitable for
            commercial use.
          </p>
          <p className="text-gray-600 mt-2">
            This includes complying with relevant health, safety, and building
            requirements applicable to the premises.
          </p>
        </div>

        {/* Legal compliance */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Legal and Regulatory Compliance
          </h2>
          <p className="text-gray-600">
            Hosts must comply with all applicable laws and regulations,
            including:
          </p>
          <ul className="list-disc pl-6 text-gray-600 space-y-2 mt-3">
            <li>Australian Consumer Law</li>
            <li>State and territory commercial or retail leasing laws</li>
            <li>Workplace health and safety obligations</li>
            <li>Anti-discrimination laws</li>
          </ul>
        </div>

        {/* Cancellations & changes */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Changes, Cancellations, and Disruptions
          </h2>
          <p className="text-gray-600">
            If a host becomes aware of any issue that may impact a tenant’s
            booking or use of the workspace, they must notify the tenant as soon
            as reasonably possible.
          </p>
          <p className="text-gray-600 mt-2">
            Hosts should act reasonably and transparently when managing changes
            or cancellations.
          </p>
        </div>

        {/* Platform conduct */}
        <div>
          <h2 className="text-2xl font-semibold mb-4">
            Professional Conduct on the Platform
          </h2>
          <p className="text-gray-600">
            Hosts must not engage in misleading, abusive, discriminatory, or
            deceptive conduct on the platform. Any behaviour that undermines
            trust may result in listing removal or account suspension.
          </p>
        </div>

        {/* Disclaimer */}
        <div className="border-t pt-8">
          <h2 className="text-2xl font-semibold mb-4">Important Disclaimer</h2>
          <p className="text-gray-600">
            AirArrange is not a party to any lease or booking agreement and does
            not guarantee host performance. Hosts remain solely responsible for
            fulfilling their obligations to tenants.
          </p>
        </div>
      </section>
    </div>
  );
}

export default HostResponsibilities;
